// filepath: /C:/Users/nitis/Desktop/uii/client/src/components/nav Components/Profile.js
import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import NavHeader from '../shared/Nav-Header';
// import SwitchButton from '../shared/switchButton'; // Import the SwitchButton component
import styles from './profile.module.css'; // Use CSS modules

const GuestProfile = () => {
    const [profile, setProfile] = useState({
        name: '',
        emailOrPhone: '',
        skills: '',
        gender: '',
        socialPoints: 0,
        education: '',
        about: '',
        profilePicture: '',
        resume: '',
        defaultMessage: '',
        // autoApply:''
    });
    const [isEditing, setIsEditing] = useState(false);
    const [notification, setNotification] = useState('');
    const [uploading, setUploading] = useState(false);
    const [resumeName, setResumeName] = useState('');
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    // const [autoApply1, setAutoApply1] = useState(false); // Initialize autoApply state
    const navigate = useNavigate();
    const [showTooltip, setShowTooltip] = useState(false);
    const token = useMemo(() => localStorage.getItem('token'), []);

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                if (!token) {
                    setIsAuthenticated(false);
                    setIsLoading(false);
                    return;
                }
                
                const response = await axios.get('/api/profile/get-profile', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                
                setProfile(response.data);
                setIsAuthenticated(true);
                // setAutoApply1(response.data.autoApply); // Set the initial value of autoApply from the profile data
                setResumeName(response.data.resume.split('/').pop());
                setIsLoading(false);
            } catch (error) {
                console.error('Error fetching profile:', error);
                localStorage.removeItem('token'); // Remove invalid token
                setIsAuthenticated(false);
                setIsLoading(false);
            }
        };

        fetchProfile();
    }, [navigate]);

    const handleLoginRedirect = () => {
        localStorage.setItem('notification', 'Please login to view your profile');
        navigate('/login');
    };

    // const handleAutoApplyChange = async (value) => {
    //     setAutoApply1(value); // Update the local state

    //     try {
    //         const token = localStorage.getItem('token');
    //         // Send the updated value to the backend
    //         await axios.put(
    //             '/api/profile/update-auto-apply',
    //             { autoApply: value },
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${token}`,
    //                 },
    //             }
    //         );
    //         setNotification('Auto Apply setting updated successfully');
    //     } catch (error) {
    //         console.error('Error updating Auto Apply setting:', error);
    //         setNotification('Error updating Auto Apply setting');
    //     }
    // };

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (isEditing) {
                event.preventDefault();
                event.returnValue = 'You have unsaved changes. Do you want to leave?';
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [isEditing]);

    const handleChange = (e) => {
        setProfile({ ...profile, [e.target.name]: e.target.value });
    };
    
    const toggleTooltip = () => {
        setShowTooltip(prev => !prev);
    };

    const handleEditClick = () => {
        setIsEditing(true);
    };

    const handleSaveClick = async () => {
        if (uploading) {
            setNotification('Please wait for the upload to complete');
            return;
        }

        try {
            await axios.put('/api/profile/update-profile', profile, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
            });
            setNotification('Profile updated successfully');
            setIsEditing(false);
        } catch (error) {
            setNotification('Error updating profile');
            console.error('Error updating profile:', error);
        }
    };

    const handleCancelClick = () => {
        setIsEditing(false);
    };

    const handleUpload = async (e, type) => {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append('file', file);
        formData.append('upload_preset', 'ml_default'); // Replace with your Cloudinary upload preset

        setUploading(true);

        try {
            const response = await axios.post('/api/upload/upload-all', formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });
            const url = response.data.url;

            setProfile({ ...profile, [type]: url });
            if (type === 'resume') {
                setResumeName(file.name);
            }

            setUploading(false);
        } catch (error) {
            console.error('Error uploading file:', error);
            setUploading(false);
        }
    };

    if (isLoading) {
        return (
            <div>
                <NavHeader />
                <div className={styles.loadingContainer}>
                    <div className={styles.loadingSpinner}></div>
                    <p>Loading profile...</p>
                </div>
            </div>
        );
    }

    return (
        <div>
            <NavHeader />
            <div className={styles.profileContainer}>
                {!isAuthenticated && (
                    <div className={styles.loginOverlay}>
                        <div className={styles.loginPrompt}>
                            <h3>Login Required</h3>
                            <p>Please login to view your profile</p>
                            <button 
                                className={styles.loginButton}
                                onClick={handleLoginRedirect}
                            >
                                Login
                            </button>
                        </div>
                    </div>
                )}
                
                <div className={`${styles.profileContent} ${!isAuthenticated ? styles.blurred : ''}`}>
                    <h2>Profile</h2>
                    {notification && <p className={styles.profileNotification}>{notification}</p>}
                    <div className={styles.profileInfo}>
                        <label>Name:</label>
                        {isEditing ? (
                            <input
                                type="text"
                                name="name"
                                value={profile.name}
                                onChange={handleChange}
                            />
                        ) : (
                            <p>{profile.name}</p>
                        )}
                    </div>
                    <div className={styles.profileInfo}>
                        <label>Email or Phone:</label>
                        {isEditing ? (
                            <input
                                type="text"
                                name="emailOrPhone"
                                value={profile.emailOrPhone}
                                onChange={handleChange}
                            />
                        ) : (
                            <p>{profile.emailOrPhone}</p>
                        )}
                    </div>
                    <div className={styles.profileInfo}>
                        <label>Skills:</label>
                        {isEditing ? (
                            <input
                                type="text"
                                name="skills"
                                value={profile.skills}
                                onChange={handleChange}
                            />
                        ) : (
                            <p>{profile.skills}</p>
                        )}
                    </div>
                    <div className={styles.profileInfo}>
                        <label>Gender:</label>
                        {isEditing ? (
                            <input
                                type="text"
                                name="gender"
                                value={profile.gender}
                                onChange={handleChange}
                            />
                        ) : (
                            <p>{profile.gender}</p>
                        )}
                    </div>
                    <div className={styles.profileInfo}>
                        <label>Social Points:</label>
                        {isEditing ? (
                            <input
                                type="number"
                                name="socialPoints"
                                value={profile.socialPoints}
                                onChange={handleChange}
                            />
                        ) : (
                            <p>{profile.socialPoints}</p>
                        )}
                    </div>
                    <div className={styles.profileInfo}>
                        <label>Education:</label>
                        {isEditing ? (
                            <input
                                type="text"
                                name="education"
                                value={profile.education}
                                onChange={handleChange}
                            />
                        ) : (
                            <p>{profile.education}</p>
                        )}
                    </div>
                    <div className={styles.profileInfo}>
                        <label>About:</label>
                        {isEditing ? (
                            <textarea
                                name="about"
                                value={profile.about}
                                onChange={handleChange}
                            />
                        ) : (
                            <p>{profile.about}</p>
                        )}
                    </div>
                    <div className={styles.profileInfo}>
                        <label>Profile Picture:</label>
                        {isEditing ? (
                            <>
                                <input
                                    type="text"
                                    name="profilePicture"
                                    value={profile.profilePicture}
                                    onChange={handleChange}
                                />
                                <input
                                    type="file"
                                    onChange={(e) => handleUpload(e, 'profilePicture')}
                                />
                            </>
                        ) : (
                            <div>
                                {profile.profilePicture ? (
                                    <img
                                        src={profile.profilePicture ? profile.profilePicture.replace('/upload/', '/upload/w_384,h_400,c_fill/') : '/default-profile.png'}
                                        alt="Profile"
                                        className={styles.profilePicture}
                                        onError={(e) => { e.target.src = '/default-avatar.png'; }}
                                        onClick={() => window.open(profile.profilePicture, '_blank')}
                                        style={{ cursor: 'pointer' }}
                                    />
                                ) : (
                                    <p>No profile picture</p>
                                )}
                            </div>
                        )}
                    </div>
                    <div className={styles.profileInfo}>
                        <label>Resume:</label>
                        {isEditing ? (
                            <>
                                <input
                                    type="text"
                                    name="resume"
                                    value={profile.resume}
                                    onChange={handleChange}
                                />
                                <input
                                    type="file"
                                    onChange={(e) => handleUpload(e, 'resume')}
                                />
                            </>
                        ) : (
                            <a href={profile.resume} target="_blank" rel="noopener noreferrer">{resumeName}</a>
                        )}
                    </div>
                    <div className={styles.profileInfo}>
                        <label>Default Message:</label>
                        {isEditing ? (
                            <input
                                type="text"
                                name="defaultMessage"
                                value={profile.defaultMessage}
                                onChange={handleChange}
                            />
                        ) : (
                            <p>{profile.defaultMessage}</p>
                        )}
                        <div className={styles.infoButtonContainer}>
                            {!isEditing && (
                                <div className={styles.infoCircle} onClick={toggleTooltip}>i</div>
                            )}
                            {showTooltip && (
                                <div className={styles.infoTooltip}>
                                    <p>Set Default Messages in profile to Send Message to Recruiters automatically.</p>
                                    <p>You can login with email or phone.</p>
                                    <p>Password must be at least 6 characters.</p>
                                    <p>Send and receive all messages are turuned ON simultaneously.</p>
                                </div>
                            )}
                        </div>
                    </div>
                    <div>
                        {/* <SwitchButton
                            isChecked={autoApply1}
                            onChange={handleAutoApplyChange}
                            label="Auto Apply"
                            value={autoApply1} // Pass the value prop to the SwitchButton
                        /> */}
                    </div>
                    {isEditing ? (
                        <div className={styles.profileActions}>
                            <button onClick={handleSaveClick} disabled={uploading}>Save</button>
                            <button onClick={handleCancelClick}>Cancel</button>
                        </div>
                    ) : (
                        <button onClick={handleEditClick}>Edit</button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default GuestProfile;